import React, { Component } from 'react';

class Personalised extends Component {
	render() {
		return (
			<section className="personalised">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-5">
							<div className="personalised__text">
								<h1>Personalised,<br/><em>Delivered</em></h1>
								<p>Free Shipping on Full Set</p>
								<p>Automatically updates with changing weather & skin needs</p>
								<p>Don’t like it? We re-formulate for you.</p>
								<div className="text-center text-sm-left">
									<a className="btn btn-primary" href="#" title="">Personalise Now</a>
								</div>
							</div>
						</div>
						<div className="col-md-7">
							<div className="personalised__img">
								<img className="mw-100" src="images/home/personalise-first.png" alt="" />
								<img className="personalised__img--bg" src="images/home/personalise-sec.png" alt="" />
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}


export default Personalised